<template>
  <div class="wrap">
    <div class="title">
      <div class="title_left">常用商品管理</div>
    </div>
    <div class="innerBox">
      <div class="filtrate">
        <el-input placeholder="搜索商品名称" class="w300 seekIpt mr20" v-model="queryLimit.goodsName" @keyup.enter.native="searchPage">
          <i slot="suffix" class="el-input__icon el-icon-search" @click="searchPage"></i>
        </el-input>
        <div class="floatR">
          <el-button class="w90 pl" @click="deleteBatch">批量删除</el-button>
          <el-button class="selectHeight mr20" type="primary" @click="openAdd">
            <i style="margin-right: 5px;font-weight: 700;color: #fff;" class="el-icon-plus"></i>新增
          </el-button>
        </div>
      </div>
      <el-divider></el-divider>
      <div class="content">
        <div class="tabOffTop120">
          <el-table ref="multipleTable" :data="tableData.records" tooltip-effect="dark" style="width: 100%" @selection-change="selectionChange">
            <el-table-column type="selection" width="80"></el-table-column>
            <el-table-column prop="" min-width="160" label="商品图片"  show-overflow-tooltip>
              <template slot-scope="scope">
                <img :src="baseUrl + '/' +scope.row.goodsFileUrl" style="width: 36px;height: 36px;">
              </template>
            </el-table-column>
            <el-table-column prop="areaName" min-width="160" label="商品品类" show-overflow-tooltip>
              <template slot-scope="scope">
                {{scope.row.thirdLevelName?scope.row.thirdLevelName:scope.row.secondLevelName}}
              </template>
            </el-table-column>
            <el-table-column prop="name" min-width="180" label="商品名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="unit" min-width="100" label="商品计量单位" show-overflow-tooltip></el-table-column>
            <el-table-column prop="prepackaged" min-width="120" label="是否预包装食品" show-overflow-tooltip>
              <template slot-scope="scope">
                {{scope.row.prepackaged=='YES'?'是':'否'}}
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="180">
              <template slot-scope="scope">
                <a href="javascript:;" class="operate-a" @click="openEdit(scope.row)">编辑</a>
                <a href="javascript:;" class="operate-a" @click="delConfirm(scope.row.id)">删除</a>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-box">
          <el-pagination background @size-change="pageSizeChange" @current-change="pageCurrentChange"
                          :current-page="queryLimit.current" :page-sizes="[10, 20, 30, 40,50]" :page-size="queryLimit.size"
                          layout="total,prev, pager, next, sizes, jumper" :total="tableData.total">
          </el-pagination>
        </div>
      </div>
    </div>
    <div class="popuoBigBox" @click="clearPopSqplBox" v-if="popuoBigShow">
      <div class="popupBox">
        <h3>添加商品<i class="close el-icon-close" @click="qxFun"></i></h3>
        <div class="contentBox">
          <el-form :model="goodsFrom" :rules="rules" ref="goodsFrom" label-width="150px">
            <div class="row mt20" @click.stop="plFun">
              <el-form-item label="商品种类：" prop="plName" style="position: relative;">
                <el-input placeholder="请选择商品品类" class="w300" :readonly="plReadOnly" v-model="plName" @focus="plFun"></el-input>
                <div class="popSqplBox" v-if="plReadOnly">
                  <div class="oneTree">
                    <h4>一级品类</h4>
                    <ul class="plUl">
                      <li v-for="(item,index) in treeList" :class="goodsFrom.firstLevelCode == item.typeCode?'okLi':''" :key="index"
                          @click.stop="plClick(item)">
                          {{item.typeName}}
                      </li>
                    </ul>
                  </div>
                  <div class="oneTree" v-if="treeTowList.length>0">
                    <h4>二级品类</h4>
                    <ul class="plUl">
                      <li v-for="(item,index) in treeTowList" :class="goodsFrom.secondLevelCode == item.typeCode?'okLi':''" :key="index"
                        @click.stop="plClickTwo(item)">
                        {{item.typeName}}
                      </li>
                    </ul>
                  </div>
                  <div class="oneTree" v-if="treeThreeList.length>0">
                    <h4>三级品类</h4>
                    <ul class="plUl">
                      <li v-for="(item,index) in treeThreeList" :class="goodsFrom.thirdLevelCode == item.typeCode?'okLi':''" :key="index"
                        @click.stop="plClickThree(item)">
                        {{item.typeName}}
                      </li>
                    </ul>
                  </div>
                </div>
              </el-form-item>
            </div>
            <div class="row">
              <el-form-item label="商品名称：" prop="name">
                <el-input placeholder="请输入商品名称" class="w300" maxlength="30" v-model="goodsFrom.name"></el-input>
              </el-form-item>
            </div>
            <div class="row">
              <el-form-item label="商品计量单位：" prop="unit">
                <el-select v-model="goodsFrom.unit" placeholder="请选择计量单位" class="w300">
                  <el-option v-for="item in unitLists" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="row">
              <el-form-item label="是否预包装食品：" prop="plName">
                <el-radio v-model="goodsFrom.prepackaged" label="YES">是</el-radio>
                <el-radio v-model="goodsFrom.prepackaged" label="NO">否</el-radio>
              </el-form-item>
            </div>
            <div class="row">
              <el-form-item label="商品图片：" prop="plName">
                <div class="pzUploadBox">
                  <ybUploadFill class="ybUpload" @changeFun="getFilesO" :baseUrl="baseUrl" :filesArr="tranVoucherList">
                  </ybUploadFill>
                </div>
                <p class="tipP tipPF">图片大小不超过5M；</p>
                <p class="tipP">上传格式：jpg、png、gif；</p>
              </el-form-item>
            </div>
          </el-form>
          <div class="btndiv">
            <el-button class="w70 mr20" @click="qxFun">取消</el-button>
            <el-button type="primary" v-if="!goodsFrom.id" class="w70 mr20" @click="bcFun('add')">保存</el-button>
            <el-button type="primary" v-if="goodsFrom.id" class="w70 mr20" @click="bcFun('edit')">保存</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as api from "api/report";
  import ybUploadFill from "components/ybUploadFill";
  export default {
    components: {
      ybUploadFill,
    },
    data() {
      return {
        queryLimit: {
          current: 1,
          goodsName: "",
          size: 10
        },
        tableData: [],
        idArr: [],
        baseUrl: this.$store.state.common.baseUrl,
        popuoBigShow: false,
        goodsFrom: {
          firstLevelCode: '', //一级分类code
          firstLevelName: '', //一级分类名称
          name: '', //商品名称
          prepackaged: '', //是否预包装食品('YES': 是,'NO': 否)
          secondLevelCode: '', //二级分类code
          secondLevelName: '', //二级分类名称
          thirdLevelCode: '', //三级分类code
          thirdLevelName: '', //三级分类名称
          unit: '', //单位
          goodsFileId: '', //商品图片
          id: '',
        },
        rules: {
          plName: [
            {
              required: true,
              message: '请选择商品品类',
              trigger: 'click'
            }
          ],
          name: [
            {
              required: true,
              message: '请输入商品名称',
              trigger: 'blur'
            }
          ],
          unit: [
            {
              required: true,
              message: '请选择计量单位',
              trigger: 'blur'
            }
          ]
        },
        unitLists: [
          '公斤','斤','两','升','毫升','颗','个','箱','件','块','袋','盒','瓶','包','把','桶','罐','听','杯','双','对','只','头','条','根','板','份','提','卷','台','串','格','盆','套','框','支','张','朵','米','束','枚','篮','筒','碗','本','副','次','托','捆','克','笼','壶','联','打','扎','片','KG',
        ],
        tranVoucherList: [],
        plReadOnly: false,
        treeList: [],
        treeTowList: [],
        treeThreeList: [],
        plName: '',
        popuoBigShow: false
      };
    },
    methods: {
      bcFun(type){
        if(!this.plName || !this.goodsFrom.name || !this.goodsFrom.unit || !this.goodsFrom.goodsFileId || !this.goodsFrom.prepackaged){
          this.$message.error('请填写完整信息');
          return
        }
        let _api = type == 'add'? api.goodsAdd:api.goodsUpdate;
        _api(this.goodsFrom).then(r=>{
          if(r.code == 200){
            this.$message.success(type == 'add'?'添加成功':'编辑成功');
            this.qxFun();
            this.getPageData();
          }
        })
      },
      qxFun(){
        this.treeTowList = [];
        this.treeThreeList = [];
        this.goodsFrom = {
          firstLevelCode: '', 
          firstLevelName: '',
          name: '',
          prepackaged: '',
          secondLevelCode: '',
          secondLevelName: '',
          thirdLevelCode: '',
          thirdLevelName: '',
          unit: '',
          goodsFileId: '',
          id: '',
        };
        this.tranVoucherList = [];
        this.plName = '';
        this.popuoBigShow = false;
      },
      plClick(item){
        this.goodsFrom.firstLevelCode = item.typeCode;
        this.goodsFrom.firstLevelName = item.typeName;
        this.treeTowList = item.children;
        this.treeThreeList = [];
      },
      plClickTwo(item) {
        this.goodsFrom.secondLevelCode = item.typeCode;
        this.goodsFrom.secondLevelName = item.typeName;
        if(item.children){
          this.treeThreeList = item.children;
        } else {
          this.plName = this.goodsFrom.firstLevelName+'/'+this.goodsFrom.secondLevelName;
          this.plReadOnly = false;
        }
      },
      plClickThree(item) {
        this.goodsFrom.thirdLevelCode = item.typeCode;
        this.goodsFrom.thirdLevelName = item.typeName;
        this.plName = this.goodsFrom.firstLevelName+'/'+this.goodsFrom.secondLevelName+'/'+ this.goodsFrom.thirdLevelName;
        this.plReadOnly = false;
      },
      clearPopSqplBox(){
        if(this.plReadOnly){
          this.plName = '';
          this.goodsFrom.firstLevelCode = '';
          this.goodsFrom.firstLevelName = '';
          this.goodsFrom.secondLevelCode = '';
          this.goodsFrom.secondLevelName = '';
          this.goodsFrom.thirdLevelCode = '';
          this.goodsFrom.thirdLevelName = '';
          this.plReadOnly = false;
          this.treeTowList = [];
          this.treeThreeList = [];
        }
      },
      plFun(){
        this.plReadOnly = true;
      },
      getFilesO(file){
        if (file.length>0) {
          this.goodsFrom.goodsFileId = file[0].fileId;
        } else {
          this.goodsFrom.goodsFileId = ''; 
        }
      },
      selectionChange(row){
        for(let i=0;i<row.length;i++){
          this.idArr.push(row[i].id)
        }
      },
      pageCurrentChange(current) {
          this.queryLimit.current = current;
          this.getPageData();
      },
      pageSizeChange(size) {
          this.queryLimit.size = size;
          this.getPageData();
      },
      // 删除
      async delConfirm(id){
          try {
              await this.$confirm('删除后无法恢复，是否确定删除? ', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
              })
              api.goodsDeleteBatch({ goodsIds: [id]}).then(res => {
                if(res.code === 200) {
                  this.$message.success('删除成功!');
                  this.getPageData();
                }
              }).catch(err => {})
          } catch (e) {
              this.$message({
                  type: 'info',
                  message: '删除失败'
              });
          }
      },
      async deleteBatch(){
        try {
          await this.$confirm('删除后无法恢复，是否确定删除? ', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          api.goodsDeleteBatch({ goodsIds: this.idArr }).then(res => {
            if (res.code === 200) {
              this.$message.success('删除成功!');
              this.getPageData();
            }
          }).catch(err => { })
        } catch (e) {
          this.$message({
            type: 'info',
            message: '删除失败'
          });
        }
      },
      openEdit(row){
        this.popuoBigShow = true;
        this.goodsFrom = JSON.parse(JSON.stringify(row));
        this.plName = `${row.firstLevelName}/${row.secondLevelName}${row.thirdLevelName?'/'+row.thirdLevelName:''}`;
        this.tranVoucherList.push({
          url: this.baseUrl + '/' +row.goodsFileUrl
        })
      },
      openAdd(){
        this.popuoBigShow = true;
      },
      searchPage(){
        this.queryLimit.current = 1;
        this.getPageData();
      },
      async getPageData(){
        api.goodsListAll(this.queryLimit).then(res => {
          if(res.code === 200) {
            this.tableData = res.data
          }
        })
      }
    },
    mounted() {
      this.getPageData();
      api.goodsTypeTree().then(r=>{
        console.log(r);
        if(r.code == 200){
          this.treeList = r.data.children;
        }
      })
    }
  };
</script>

<style scoped lang="scss">
  .popuoBigBox{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9;
    background: rgba(51, 51, 51, 0.6);
    overflow: auto;
    .popupBox{
      border-radius: 4px;
      width: 630px;
      position: absolute;
      top: calc(50% - 250px);
      left: calc(50% - 315px);
      background: #fff;
      h3{
        height: 56px;
        line-height: 56px;
        background: #FFFFFF;
        border-radius: 4px 4px 0px 0px;
        color: #333333;
        font-size: 16px;
        padding: 0 20px;
        border-bottom: 1px solid #eeeeee;
        font-weight: normal;
        i{
          float: right;
          margin-top: 17px;
          font-size: 20px;
          cursor: pointer;
        }
      }
      .contentBox{
        background: #FFFFFF;
        padding: 0px 0 20px 40px;
        border-radius: 0px 0px 4px 4px;
      }
      .btndiv{
        margin-top: 20px;
        text-align: right;
      }
    }
    .popSqplBox{
      padding: 20px 10px 20px 20px;
      background: #fff;
      z-index: 99;
      position: absolute;
      border-radius: 2px;
      border: 1px solid #DDDDDD;
      width: 510px;
      max-height: 480px;
      overflow-y: auto;
      h4{
        color: #333333;
        font-size: 18px;
        font-weight: normal;
      }
      .plUl{
        display: flex;
        flex-wrap: wrap;
        li{
          height: 32px;
          line-height: 32px;
          padding: 0 14px;
          margin-right: 10px;
          color: #666666;
          font-size: 14px;
          margin-top: 16px;
        }
        .okLi{
          background: #70CE97;
          color: #fff;
        }
      }
    }
    .ybUpload{
      width: 100px;
      height: 100px; 
      overflow: hidden;
    }
    .tipP{
      color: #999999;
      font-size: 14px;
      line-height: 20px;
    }
    .tipPF{
      margin-top: 20px;
      margin-bottom: 10px;
    }
  }
  .wrap {
    width: calc(100% - 40px);
    padding: 0 20px;
    height: 100%;
    background: #f6f6f6;
    .title {
      height: 60px;
      line-height: 60px;
      .title_left {
        font-size: 20px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        width: 50%;
        height: 100%;
      }
    }
    .innerBox {
      width: calc(100% - 60px);
      padding: 20px 30px;
      height: calc(100% - 125px);
      background: #fff;
      border-radius: 10px;
      overflow: scroll;
      .filtrate {
        vertical-align: center;
        color: #666666;
        font-size: 12px;
      }
    }
    .pagination-box {
      text-align: right;
      margin-top: 20px;
    }
  }
</style>
<style>
  .pzUploadBox .el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 120px;
  }
  .pzUploadBox .el-upload-list--picture-card .el-upload-list__item {
    width: 100px;
    height: 100px;
  }
</style>